import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add a request interceptor to include the JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const getJobs = () => api.get('/jobs');
export const getConfigs = () => api.get('/configs');
export const getRoles = () => api.get('/roles');
export const triggerJob = (scraperName) => api.post(`/jobs/trigger/${scraperName}`);
export const killSwitch = () => api.post('/kill-switch');
export const saveConfig = (site_name, yaml_content, prompt, webhook_url, snowflake_target_id, excel_target_id, google_sheet_target_id) => 
  api.post('/configs', { site_name, yaml_content, prompt, webhook_url, snowflake_target_id, excel_target_id, google_sheet_target_id });
export const createUser = (userData) => api.post('/users', null, { params: userData });
export const generateAIConfig = (prompt, context) => api.post('/configs/generate-ai', { prompt, context });
export const analyzePortal = (url, prompt) => api.post('/configs/analyze', { url, prompt });
export const downloadTrace = (jobId) => `${API_BASE_URL}/jobs/${jobId}/trace`;
export const cleanupAlarms = () => api.delete('/alarms/cleanup');

export default api;
